 import p1 from './items-pic/1.avif'
 import p2 from './items-pic/2.avif'
 import p3 from './items-pic/3.avif'
 import p4 from './items-pic/4.avif'
 import p5 from './items-pic/5.avif'
 import p6 from './items-pic/6.avif'
 import p7 from './items-pic/7.avif'
 import p8 from './items-pic/8.avif'
 import p9 from './items-pic/9.avif'
 import p10 from './items-pic/10.avif'
 import p11 from './items-pic/11.avif'
 import p12 from './items-pic/12.avif'
 import p13 from './items-pic/13.avif'
 import p14 from './items-pic/14.avif'
 import p15 from './items-pic/15.avif'
 import p16 from './items-pic/16.avif'
 import p17 from './items-pic/17.avif'
 import p18 from './items-pic/18.avif'
 import p19 from './items-pic/19.avif'
 import p20 from './items-pic/20.avif'
 import p21 from './items-pic/21.avif'
 import p22 from './items-pic/22.avif'
 import p23 from './items-pic/23.avif'
 import p24 from './items-pic/24.avif'
 import p25 from './items-pic/25.avif'
 
 const items=
 [
  {
  id:1,
  pic:p1,
  price1:0.1418,
  price2:0.9217,
  dis:'Ausdirect Leading Air and Sea Freight Forwarder China to Australia New Zealand Best China Shipping AgentReorder rate 27%',
  year:'2'
},
  {
  id:2,
  pic:p2,
  price1:4.24,
  price2:4.95,
  dis:'Custom Straps Compatible with the WHOOP Band (latest Generation) Breathable',
  year:'1'
},
  {
  id:3,  
  pic:p3,
  price1:0.2127,
  price2:0.709,
  dis:'DDP Fast Air Freight Ali UPS DHL Express Shipping Agent From China to SA Saudi Arabia UAE Qatar Kuwait Oman Iraq ForwarderReorder rate 28%',
  year:'9'
},
  {
   id:4, 
  pic:p4,
  price1:0.7516,
  price2:0.787,
  dis:'Wholesale Lip Balm and Hand Cream Set Deep Moisturizing Repairing Dry and Cracking Lip',
  year:'7'
},
  {
  id:5,  
  pic:p5,
  price1:0.7516,
  price2:0.787,
  dis:'Schylling Needoh Nice Cube Cross-border Explosions Sensory Toys Decompression Square Pinch Music Decompression Vent ToysReorder rate 15%',
  year:'1'
},
  {
  id:6,  
  pic:p6,
  price1:57.82,
  price2:0,
  dis:'High-Grade OMG600 Stainless Steel Watch Parts Case Dial &amp; Bezel Assembly Super Blue Luminous Sapphire Glass-Durable ShockproofReorder rate 39%',
  year:'2'
},
  {
  id:7,  
  pic:p7,
  price1:0.8508,
  price2:1.07,
  dis:'High-Grade OMG600 Stainless Steel Watch Parts Case Dial &amp; Bezel Assembly Super Blue Luminous Sapphire Glass-Durable ShockproofReorder rate 39%',
  year:'6'
},
  {
  id:8,  
  pic:p8,
  price1:0.5743,
  price2:0,
  dis:'Mirawell Hot Sale 18k Gold Stainless Steel Geometric Stud Earrings High-end Niche Instagram Women\'s Trendy Cross-border',
  year:'1'
},
  {
  id:9,  
  pic:p9,
  price1:0.2836,
  price2:0.709,
  dis:'Door to Door Freight Forwarder China to UAE Saudi Arabia Oman',
  year:'1'
},
  {
  id:10,  
  pic:p10,
  price1:39,
  price2:41.13,
  dis:'Paper Material Suitable for 14 Year',
  year:'1'
},
  {
  id:11,  
  pic:p11,
  price1:0.5602,
  price2:0.6594,
  dis:'Fashion Cherry Keychain Metal Fruit Resin Keychains for Bag',
  year:'6'
},
  {
  id:12,  
  pic:p12,
  price1:0.3475,
  price2:0.6311,
  dis:'2026 squeeze toys Squishy Dumpling Squishy Bun Toys',
  year:'6'
},
  {
  id:13,  
  pic:p13,
  price1:0.0709,
  price2:0.2127,
  dis:'Fast Cheap Shipping Agent China to Dominican Rio Haina Santo',
  year:'2'
},
  {
  id:14,  
  pic:p14,
  price1:0.3191,
  price2:0.4609,
  dis:'Hot Selling Creative Glitter Squeeze Dumplings Fidget Toys Dumpling Squishy Sensory',
  year:'3'
},
  {
  id:15,  
  pic:p15,
  price1:0.4254,
  price2:0,
  dis:'PENNYFEN Color Changing Lip Balm Hand Cream Set Skin Care',
  year:'5'
},
  {
  id:16,  
  pic:p16,
  price1:0.9217,
  price2:0,
  dis:'European American Vintage Style Trendy Earrings for Women',
  year:'2'
},
  {
  id:17,  
  pic:p17,
  price1:0.156,
  price2:0,
  dis:'Genuine Sanli Pinch Fun PU Decompression Squeeze Stress',
  year:'1'
},
  {
  id:18,  
  pic:p18,
  price1:50.80,
  price2:69.27,
  dis:'Acrylic Icy Blue Mahjong Tile Set Four-Layer Luxury Style Fade',
  year:'1'
},
  {
  id:19,  
  pic:p19,
  price1:1.78,
  price2:2.13,
  dis:'Viral Squish Toy Needoh Nice Ice Cream Cone Gradient Ice Cream Stress Relief Squeeze Toy',
  year:'1'
},
  {
  id:20,  
  pic:p20,
  price1:0.4822,
  price2:0.5743,
  dis:'Mechanical Stress Relief Plastic Square Keyboard Anime Cartoon',
  year:'2'
},
  {
  id:21,  
  pic:p21,
  price1:1.56,
  price2:2.06,
  dis:'Giant Banana Squishy Toy TPR Material Stress Relief Fidget',
  year:'1'
},
  {
  id:22,  
  pic:p22,
  price1:216.25,
  price2:290.69,
  dis:'Wholesale 99% New Original US Version Unlocked Used Mobile',
  year:'1'
},
  {
  id:23,  
  pic:p23,
  price1:0.1773,
  price2:1.06,
  dis:'International Logistic Dhl air Freight Rates Forwarder China',
  year:'2'
},
  {
  id:24,  
  pic:p24,
  price1:0.8863,
  price2:1.32,
  dis:'Foot Care Cream for Cracked Heels Exfoliating Anti Crack',
  year:'7'
},
  {
  id:25,  
  pic:p25,
  price1:42.54,
  price2:343.87,
  dis:'Factory Cheap Price Coin',
  year:'12'
},

 ];
 
export default items